import createCustomApp from '../utils/vue';
import TopMedicalInstitutionLogoSlider from '../components/TopMedicalInstitutionLogoSlider.vue';

createCustomApp(TopMedicalInstitutionLogoSlider).mount('[data-vue="slider"]');
